<template>
  <div class="sub-header">
    <div class="sub-header-content">
      <v-btn icon @click="toggleDrawer" color="var(--color-text)">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <div class="sub-header-title">{{ title }}</div>
      <slot name="info"></slot>
      <v-spacer></v-spacer>
      <slot name="trailing"></slot>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "SubHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("main", ["toggleDrawer"]),
  },
};
</script>

<style scoped>
.sub-header {
  background: var(--color-bg) !important;
  padding: 8px;
  height: fit-content;
}
.sub-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sub-header-title {
  font-size: 18px;
  font-weight: bold;
  color: var(--color-text);
}
</style>

